import React from 'react';

const Backdrop = (props) => {
    const { setMenuOpen } = props;

    return (
        <div
            className='backdrop'
            onClick={() => setMenuOpen(false)}
        >
        </div>
    );
};

export default Backdrop;
